import { render, staticRenderFns } from "./uniqueStockByCustomer.vue?vue&type=template&id=15b79593&scoped=true&"
import script from "./uniqueStockByCustomer.vue?vue&type=script&lang=js&"
export * from "./uniqueStockByCustomer.vue?vue&type=script&lang=js&"
import style0 from "./uniqueStockByCustomer.vue?vue&type=style&index=0&id=15b79593&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b79593",
  null
  
)

export default component.exports